import Async from "async";
import moment from "moment";

export const calculatePrice = (products) => {
    let totalPrice = 0;
    Async.each(products, (item, cb) => {
        totalPrice += (item.price ? item.price : 0) * (item.quantity ? item.quantity : 0);
        cb()
    }, () => {
        return totalPrice;
    })
}

export const numberOnly = (value) => {
    if (!value) {
        return
    } else {
        let transformedInput = value.replace(/[^0-9]/g, '');
        return transformedInput ? parseInt(transformedInput) : '';
    }
}

export const mobileNumber = (value) => {
    if (!value) {
        return
    } else {
        let transformedInput = value.replace(/[^0-9]/g, '');
        return transformedInput;
    }
}

export const cvvNumber = (value) => {
    if (!value) {
        return
    } else {
        let transformedInput = value.replace(/[^0-9]/g, '');
        return transformedInput;
    }
}

export const digitOnly = (val) => {
    if (!val) {
        val = ''
    }
    let clean = val.replace(/[^-0-9\.]/g, '');
    let negativeCheck = clean.split('-');
    let decimalCheck = clean.split('.');
    if (negativeCheck && negativeCheck.length > 1 && negativeCheck && !negativeCheck[1]) {
        negativeCheck[1] = negativeCheck[1].slice(0, negativeCheck[1].length);
        clean = negativeCheck[0] + '-' + negativeCheck[1];
        if (negativeCheck[0].length > 0) {
            clean = negativeCheck[0];
        }
    }
    if (decimalCheck && decimalCheck.length > 1 && decimalCheck[1]) {
        decimalCheck[1] = decimalCheck[1].slice(0, 2);
        clean = decimalCheck.join('.');
    }
    return clean;
}

export const cardExpiryField = (val) => {
    if (!val) {
        val = ''
    }
    let clean = val.replace(/[^0-9]/g, '');
    let decimalCheck = clean.split('/');
    let month = ''
    let year = ''
    if (clean >= 0) {
        let totalLength = clean.length;
        if (totalLength >= 2) {
            month = clean.slice(0, 2);
            year = clean.slice(2, 4);
        }

        if (month && year) {
            /* let currentYear = parseInt(moment().format('yy'))
             if (parseInt(month) > 12 || parseInt(year) < currentYear) {
                 clean = ''
             } else {
                 clean = `${month}/${year}`
             }*/
            clean = `${month}/${year}`
        }
    }
    return clean;
}

export const checkEmailIsValid = (value) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        return (true)
    } else {
        return (false)
    }
}


export const dayList = [
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
]

export const frequencyList = {
    1: 'Every Week',
    2: 'Every 2 Weeks',
    3: 'Every 3 Weeks',
    4: 'Every 4 Weeks'
}
export const daysList = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
}

// export const servingList = ['Just Me', 'A Couple', 'A Family']
export const servingList = ['Weekly', 'Every 2 weeks', 'Once a month', 'Not often (random use)']

export const serviceListArr = [
    'Dry cleaning',
    'Leather/suede/fur cleaning',
    'Wash and fold laundry service',
    'Rug cleaning',
    'Curtain cleaning',
    'Cushion cleaning',
    'Trainer cleaning',
    'Duvet and pillow cleaning',
    'Ironing only',
    'Repairs and alterations',
    'Shirt cleaning',
    'Bed linen cleaning'
]

export const serviceListArrNew = [
    {
        id: 'DryCleaning',
        name: 'Dry cleaning',
        info: "For delicate items and fabrics, cleaned individually. Items washed/dry cleaned, as appropriate, " +
            "ironed and delivered on hangers by default, folding can be requested on order notes. Minimum 72 hr service."
    },
    {
        id: 'LeatherSuedeFurCleaning',
        name: 'Leather/suede/fur cleaning',
        info: "Specialist dry cleaning service for luxury items or items with fabrics of leather suede or fur. Turnaround is 10-14 days."
    },
    {
        id: 'WashAndFoldLaundryService',
        name: 'Wash and fold laundry service',
        shortName: 'Wash and fold service',
        info: "Everyday Laundry, a simple wash, dry and fold service. 24 hrs available upon request for £5, please add " +
            "to order notes if you would like this. Delivered in 1 Stop Wash Bag."
    },
    {
        id: 'RugCleaning',
        name: 'Rug cleaning',
        info: "Individually dry cleaned and dried before being bagged into 1 Stop Wash Bag. Turnaround varies with " +
            "size but tends to be 10-14 days. Our expert rug cleaning sales team will be in touch upon order " +
            "confirmation to confirm a quote before collection."
    },
    {
        id: 'CurtainCleaning',
        name: 'Curtain cleaning',
        info: "Individually dry cleaned, air dried & pressed before being bagged into 1 Stop Wash Bag. Turnaround " +
            "varies with size but tends to be 10-14 days. Our expert curtain cleaning sales team will be in touch upon " +
            "order confirmation to confirm a quote before collection."
    },
    {
        id: 'CushionCleaning',
        name: 'Cushion cleaning',
        info: "Individually dry cleaned, pressed and bagged into 1 Stop Wash Bag. Turnaround varies from item to item, " +
            "rugs & curtains estimated 10-14 days, sofa covers & cushions tend to be 3-4 days."
    },
    {
        id: 'TrainerCleaning',
        name: 'Trainer cleaning',
        info: "Trainers pre spotted, cleaned using state of the art equipment, air dried overnight and packed into 1 Stop " +
            "Wash Bag. Minimum 7-10 day turnaround. Our expert trainer cleaning sales team will be in touch " +
            "to confirm a quote before collection."
    },
    {
        id: 'DuvetAndPillowCleaning',
        name: 'Duvet and pillow cleaning',
        info: "Items are washed, dried and packed into 1 Stop Wash bag. Turnaround is 48hrs unless it’s feather which is 72hrs."
    },
    {
        id: 'IroningOnly',
        name: 'Ironing only',
        info: "Individually pressed only and folded into 1 Stop Wash Bag. 48 hr service. Please note, shirts are excluded from iron only."
    },
    {
        id: 'RepairsAndAlterations',
        name: 'Repairs and alterations',
        info: "In house repairs & alterations tailor with 25 years experience to bring your items back to life. Book " +
            "appointment with our tailor for most accurate measurements at hello@1stopwash.com. Minimum 4-7 " +
            "days turnaround depending on job size."
    },
    {
        id: 'ShirtCleaning',
        name: 'Shirt cleaning',
        info: "Individually washed/dry cleaned as appropriate, pressed and delivered on hanger by default. Additional " +
            "folding can be requested by adding to order notes. 48hr service."
    },
    {
        id: 'BedLinenCleaning',
        name: 'Bed linen cleaning',
        info: "Bed Linen washed & pressed, bulky items such as duvets & pillows washed and dried. *Bed set counts " +
            "as 2 pillow cases, 1 bed sheet & 1 duvet cover. Minimum 48 hrs."
    }
]

export const faqList = [
    {
        "question": "Where do I give my list of items?",
        "answer": `<p> You can personalise your order with instructions in the select services page or the order summary. However, you do not need to give a full itemised list. We'll count them and send you a full list with cleaning costs after collecting them.</p>`
    },
    {
        "question": "How does payment work?",
        "answer": `
            <p>Payment will only be taken after we've collected your items & cleaned them - you can estimate the price of your order using our price estimator. \n</p>
            <br/>
            <p>We’ll ask for your card details once you have submitted your order, you can allow us to hold the card on file, otherwise you can skip this and wait until cleaning has been completed, we’ll then send a payment link for your order before we deliver it. </p>
        `
    },
    {
        "question": "How should I prepare my items for collection?",
        "answer": `<p>You can put your items in any plastic bag for your first collection. We'll provide you with a 1 Stop Wash bag for your future orders.</p>`
    },
    {
        "question": "Are there any delivery charges or service fees?\n",
        "answer": `<p>There is zero hidden charge. We have a minimum spend of £25 per collection which includes free collection & delivery. No service fees are applied. When we say no hidden fees, we mean it!</p>`
    },
    {
        "question": "What if my order is below the minimum amount?\n",
        "answer": `<p>You can still place an order with us as normal, and we'll automatically apply a top-up to your order so it meets our minimum order value of £25. We'd recommend giving us enough items to make sure you meet the minimum order value, so you can get the most value for money.</p>`
    },
    {
        "question": "What if I'm not in or need to reschedule?\n",
        "answer": `<p>You can reschedule or cancel your order up till 6pm on the day of collection free of charge, either through amending your booking online or by contacting us directly via email or whatsapp. </p>`
    },
    {
        "question": "Where are my items cleaned?",
        "answer": `<p>They are all brought back to our HQ in Kings Cross where we have been cleaning clothes and household items for 15+ years, no random outsourced factories, we clean all items in house with our expert and dedicated team of professionals.</p>`
    }
]
